export default function TimeLine() {

    return (

        <section className="professional-timeline">

            <h2>Professional Development</h2>

            <ul className="timeline">

                <li>
                    <div className="direction-r">
                        <div className="flag-wrapper">
                            <span className="flag">UI Developer &middot; Surrey</span>
                        </div>
                        <div className="desc">
                            Working on the front end of intranet designs, fixing design bugs, creating customised design packages.
                        </div>
                    </div>
                    <div className="direction-l"><span className="time">2022 &middot; PRESENT</span>
                    </div>
                </li>

                <li>
                    <div className="direction-l">
                        <div className="flag-wrapper">
                            <span className="flag flag-l">Web Developer &middot; Kent</span>
                        </div>
                        <div className="desc">
                            Working within an agency, designing, developing websites, managing projects and meeting the needs of clients.
                        </div>
                    </div>
                    <div className="direction-r">
                        <span className="time">2021 &middot; 2022</span>
                    </div>
                </li>

                <li>
                    <div className="direction-r">
                        <div className="flag-wrapper">
                            <span className="flag">Lead Developer &middot; London</span>
                        </div>
                        <div className="desc">
                            Developing hundreds of websites for mainly the education sector, taking the designs and implementing them into the custom purpose CMS.
                        </div>
                    </div>
                    <div className="direction-l"><span className="time">2016 &middot; 2021</span>
                    </div>
                </li>

                <li>
                    <div className="direction-l">
                        <div className="flag-wrapper">
                            <span className="flag flag-l">Internship &middot; West Yorkshire</span>
                        </div>
                        <div className="desc">
                            Implemented a design into a Wordpress theme, PHP bugs and miscellaneous tickets.
                        </div>
                    </div>
                    <div className="direction-r"><span className="time">2015 &middot; 2016</span>
                    </div>
                </li>

                <li>
                    <div className="direction-r">
                        <div className="flag-wrapper">
                            <span className="flag">University &middot; West Yorkshire</span>
                        </div>
                        <div className="desc">
                            Received a 2.1 at the University of Bradford on the subject of web development.<br /><br />
                        </div>
                    </div>
                    <div className="direction-l"><span className="time">2012 &middot; 2015</span>
                    </div>
                </li>

            </ul>

        </section>

    );
}
